import { Settings } from 'luxon';

// Invalid dates throw instead of turning into an invalid DateTime; the app's date handling relies on it.
Settings.throwOnInvalid = true;
